import { Injectable } from '@nestjs/common';
import { Recruitment } from '../recruitment.entity';
import { RecruitmentDTO } from './recruitment-dto';

@Injectable()
export class RecruitmentAdapter {
    /**
     * 
     * @param recruitmentDto 
     * @param isUpdate 
     * @returns 
     */
    public convertDtoToEntity(recruitmentDto: RecruitmentDTO, isUpdate: boolean = false): Recruitment {
        const recruitment = new Recruitment();
        recruitment.recruitmentId = recruitmentDto.recruitmentId;
        recruitment.recruitmentMode = recruitmentDto.recruitmentMode;
        // company.isActive = statesDto.isActive == undefined ? true : statesDto.isActive;
        recruitment.isActive = recruitmentDto.isActive == undefined ? true : recruitmentDto.isActive;
        if (isUpdate) {
            recruitment.updatedUser = recruitmentDto.updatedUser;
        } else {
            recruitment.isActive = true;
            recruitment.createdUser = recruitmentDto.createdUser;
        }
        return recruitment;
    }
    public convertEntityToDto(recruitmentObject: Recruitment): RecruitmentDTO {
        const recruitmentDto = new RecruitmentDTO;
        recruitmentDto.recruitmentId = recruitmentObject.recruitmentId;
        recruitmentDto.recruitmentMode = recruitmentObject.recruitmentMode;
        recruitmentDto.isActive = recruitmentObject.isActive;
        recruitmentDto.createdAt = recruitmentObject.createdAt;
        recruitmentDto.updatedAt = recruitmentObject.updatedAt;
        recruitmentDto.createdUser = recruitmentObject.createdUser;
        recruitmentDto.updatedUser = recruitmentObject.updatedUser;
        recruitmentDto.versionFlag = recruitmentObject.versionFlag;
        return recruitmentDto;
    }
}
